// extracted by mini-css-extract-plugin
export var colon = "CountdownTimer_colon__IUpiP";
export var timeBlock = "CountdownTimer_timeBlock__P3CaN";
export var timeContainer = "CountdownTimer_timeContainer__wotdO";
export var timer = "CountdownTimer_timer__rKP4o";
export var timerHeader = "CountdownTimer_timerHeader__G8VVz";